var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitch = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitch account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37463 11.4242V23.9447H12.6864V26.293H15.0406L17.3911 23.944H20.9199L25.6254 19.2505V8.29297H9.54988L8.37463 11.4242ZM11.1181 9.85672H24.0571V18.466L21.3121 21.205H16.9989L14.6484 23.5502V21.205H11.1181V9.85672Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4332 12.9883H17.0007V17.6833H15.4332V12.9883Z",
    fill: "#4987FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7438 12.9883H21.312V17.6833H19.7438V12.9883Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitch.afa1438166569ae2fb218f0e8c930388.svg";